import { Colors } from "@zapier/design-system";
import { ColorOrTransparent } from "../types";

export function getColorDotStyling(color: ColorOrTransparent, size = 22) {
  return {
    borderRadius: "50%",
    backgroundColor: color,
    width: size,
    height: size,
    border:
      color === "#fff" || color === "transparent"
        ? `1px solid ${color === "#fff" ? Colors.GrayWarm6 : "#ccc"}`
        : "none",
  };
}
